/* eslint-disable */
import { Contact } from '../models/contact.model';

export const mockContact: Contact = {
  forename: 'John',
  surname: 'Smith',
  person_gid: '216750842',
  person_did: 'E9E552E2-9D56-44A2-B0A1-A8194632E8F8',
  mobile_tel: '07400549517',
  home_tel: '02034445555',
  work_tel: '02089993333',
  contact_email: 'John.Smith@Gmail.com',
};
